import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt, faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
import { computed } from "vue";
import { useNotificationsStore } from "@/stores/notificationsStore";
import { absPath } from "@/utils/redirect";
import { capitalizeFirstLetter } from "@/utils/strings";
import NotificationActions from "@/components/Notifications/NotificationActions.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SharedItemNotification',
    props: {
        notification: null
    },
    setup(__props) {
        const props = __props;
        library.add(faExternalLinkAlt, faRetweet);
        const notificationsStore = useNotificationsStore();
        const content = computed(() => props.notification.content);
        const sharedItemType = computed(() => {
            if (content.value.item_type) {
                return capitalizeFirstLetter(content.value.item_type);
            }
            else {
                return "Item";
            }
        });
        const notificationVariant = computed(() => {
            switch (props.notification.variant) {
                case "urgent":
                    return "danger";
                default:
                    return props.notification.variant;
            }
        });
        const sharedItemUrl = computed(() => {
            return absPath(content.value.slug);
        });
        function markNotificationAsSeen() {
            notificationsStore.updateNotification(props.notification, { seen: true });
        }
        return { __sfc: true, props, notificationsStore, content, sharedItemType, notificationVariant, sharedItemUrl, markNotificationAsSeen, faExternalLinkAlt, faRetweet, FontAwesomeIcon, BLink, NotificationActions };
    }
});
